export default {
  root: {
    padding: ".5em"
  }
}
